module.exports = __webpack_public_path__ + "static/media/pen-nib.fd419b04.svg";